// npm
import uuidv4 from 'uuid/v4';
var IdGenerator = {
  uuid: function uuid() {
    return uuidv4();
  }
};
Object.freeze(IdGenerator);
export { IdGenerator };